<!--
 * @Author: RYL
 * @Description: 
 * @Date: 2020-10-22 15:59:16
 * @LastEditTime: 2020-10-28 11:07:41
-->
<template>
  <div>
    <TableComponent 
      :Columns="Columns"
      ref="devicesTable"
      :data="deviceList"
      radioLabel="deviceId"
      @GetStatus="GetStatus"
      @handleSelectionChange="handleSelectionChange"
      :seek="seek">
      <span slot="slot" slot-scope="scope" style="color:#409eff;font-size:15px;">{{scope.scope.$index}}</span>
    </TableComponent>
    <pagination
      :total="total"
      :offset="offset"
      :limit="limit"
      @SizeChanges="SizeChanges"
      @CurrentChanges="CurrentChanges">
    </pagination>
  </div>
</template>
<script>
import pagination from "@/components/pagination"
import TableComponent from '@/components/TableComponent/index'
import { PublicComponent } from "@/mixins/common"
import { Columns } from './tableConfig'
import { getDeviceList } from '@/api/cloudMonitor/deviceList'
export default {
  mixins: [PublicComponent],
  components: {
    pagination,
    TableComponent
  },
  data() {
    return {
      Columns,
      deviceList: [],
      seek: {
        deviceSn: "", //序列号
        deviceGname: "", //组名
        deviceName: "", //设备名
        deviceIp: "", //ip地址
        deviceIsconnected: "", //状态‘3’表示连接，其他断开'
        deviceTraffic: "", //流量
        signalStrength: "", //信号强度
        nettype: "", //网络制式0   NONE 1 GSM 2 GPRS 3 CDMA&EVDO 4 CDMA 5 EVDO 6 WCDMA 7 HSDPA 8 HSUPA 9 HSPA+ 10 TD-SCDMA 11 FDD-LTE 12 TD-LTE 13 AUTO
        deviceOnlinetime: "", //在线时长
        deviceUpdate: "", //最后活跃
        deviceSoftwareVer: "", //软件版本
        deviceAddress: "" //设备位置
      },
      deviceSelection: {}
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    // 获取设备列表
    getList() {
      let params = {
        current: this.offset,
        size: this.limit
      }
      getDeviceList(params).then(res => {
        if(res.data.code === 0) {
          let data = res.data.data
          this.deviceList = data.records
          this.deviceList.unshift({})
          this.total = data.total
        }
      })
    },
     //表格状态
    GetStatus(status){
      return {
        status:status == 3 ? 'success':'danger',
        TagName:status == 3 ? this.$t("lang.devicelist.connected") : this.$t("lang.devicelist.not")
      }
    },
    // 获取选中项
    handleSelectionChange(val) {
      this.deviceSelection = val
    },
    // 获取选择项
    getSelection() {
      return this.deviceSelection
    }
  }
}
</script>